// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"loading_loadingContainer__34MO2","logo":"loading_logo__1zBM7"};